import { AuthState } from './types'

export const initialAuthState: AuthState = {
  user: null,
  authToken: null,
  refreshToken: null,
  _hasHydrated: false,
}
